// The AI models a user can pick. One list, used by Settings and the Workspace.
//
// Settings and the Workspace each kept their own copy of this list, and the
// backend's PATCH /me/settings had a third — hardcoded to the two legacy
// aliases "claude" and "gpt". None of the models offered here were accepted,
// so the Settings picker always failed with "Couldn't save", and the
// Workspace ignored the saved preference anyway. Keys must match MODEL_MAP in
// backend/server.py; a backend test fails if they drift.
//
// Pure module, no React, so it can be tested directly.

export const MODELS = [
    { value: "claude-sonnet-5", label: "Claude Sonnet 5" },
    { value: "claude-opus-5", label: "Claude 5.0 Opus" },
    { value: "gpt-5.4", label: "GPT-5.4" },
    { value: "gpt-5.6-sol", label: "GPT-5.6 Sol" },
];

export const DEFAULT_MODEL = "claude-sonnet-5";

// Values stored before the current model keys existed.
const LEGACY = { claude: "claude-sonnet-5", gpt: "gpt-5.4" };

const KNOWN = new Set(MODELS.map((m) => m.value));

/** Map any stored value — current, legacy, missing or junk — to a real key. */
export function normalizeModel(value) {
    const v = LEGACY[value] || value;
    return KNOWN.has(v) ? v : DEFAULT_MODEL;
}

/** Whether `key` is in the user's allowed list. Unknown list → allow; the backend still enforces. */
export function isModelAllowed(key, allowed) {
    return !Array.isArray(allowed) || allowed.includes(key);
}

/** The model to actually use: the saved preference if the plan allows it, else the default. */
export function effectiveModel(preferred, allowed) {
    const key = normalizeModel(preferred);
    return isModelAllowed(key, allowed) ? key : DEFAULT_MODEL;
}
